import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CookieBanner() {
  const navigate                  = useNavigate();
  const [visible, setVisible]     = useState(false);

  useEffect(() => {
    // Only show if consent not already given
    const consent = localStorage.getItem("vs_cookie_consent");
    if (!consent) {
      // Small delay so it doesn't pop up instantly
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("vs_cookie_consent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("vs_cookie_consent", "essential_only");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 80 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6
            md:max-w-md z-50"
        >
          <div className="bg-[#0f172a] border border-white/10 rounded-[2rem]
            p-6 shadow-2xl shadow-black/40">

            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-red-600/10 border border-red-600/20
                  rounded-xl flex items-center justify-center">
                  <Cookie size={18} className="text-red-500" />
                </div>
                <p className="text-xs font-black text-white uppercase tracking-widest">
                  Cookie Notice
                </p>
              </div>
              <button
                onClick={handleDecline}
                className="w-7 h-7 rounded-lg flex items-center justify-center
                  text-slate-500 hover:text-white hover:bg-white/10 transition-all"
              >
                <X size={14} />
              </button>
            </div>

            {/* Body */}
            <p className="text-slate-400 text-xs font-medium leading-relaxed mb-5">
              VicShield uses essential cookies for authentication and session
              management. We do not use advertising or tracking cookies.
              {" "}
              <button
                onClick={() => navigate("/privacy")}
                className="text-red-400 hover:text-red-300 transition-colors
                  font-black underline underline-offset-2"
              >
                Privacy Policy
              </button>
            </p>

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                onClick={handleDecline}
                className="flex-1 py-3 border border-white/10 rounded-xl
                  text-xs font-black text-slate-400 uppercase tracking-widest
                  hover:border-white/20 hover:text-white transition-all"
              >
                Essential Only
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 py-3 bg-red-600 rounded-xl text-xs font-black
                  text-white uppercase tracking-widest hover:bg-red-700
                  transition-all flex items-center justify-center gap-2"
              >
                Accept <ChevronRight size={13} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
